import React, { useEffect, useState } from 'react';
import { post } from '../../common/http';
import { useNavigate } from 'react-router-dom';

export default function Login() {
    const navigate = useNavigate();
    const [values, setValues] = useState({ id: '', pw: '', });
  
  const handleChange = e => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    })
  }

  const onSubmit = async e => {
    e.preventDefault();
    console.log(values);
    const rslt = await post('/api/login', values);
    // if (rslt.data) setLoginUser(rslt.data);
    if (rslt.token) {  
        return navigate('/slots');
    }
    alert(rslt.message);
  };
  

  return (

    <div class="signin-container">
		<form class="signin-form" onSubmit={onSubmit}>
			<div class="logo">
				<img src="/static/img/logo/logo_300_36.png" alt="logo" />
			</div>
			<div class="form-field">
				<label class="field-lable">아이디</label>
				<div class="field-input">
					<input type="text" name="id" placeholder="아이디를 입력해주세요." value={values.id} onChange={handleChange} />
				</div>
			</div>
			<div class="form-field">
				<label class="field-lable">비밀번호</label>
				<div class="field-input">
					<input type="password" name="pw" placeholder="비밀번호를 입력해주세요." value={values.pw} onChange={handleChange} />
				</div>
			</div>
			<div class="form-auth">
				<label class="checkbox">
					<input type="checkbox" name="remember" />
					<span>아이디 기억하기</span>
				</label>
			</div>
			<button type="submit" class="form-submit-btn">
				<span>로그인</span>
			</button>
		</form>
	</div>
  )
}
